﻿export interface IEmailSendeeDeleteRequest {
    emailTemplateId: number;
    emailSendeeId: number;
}
